"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.DEV_AUTH = exports.PHONE_AUTH = void 0;
exports.PHONE_AUTH = {
    HEADING: 'What’s your number?',
    EMAIL_LOGIN_CTA: 'Having trouble? Log in with email',
    SUBHEADING: 'We’ll send you a code to verify your account and keep it secure.',
    PHONE_LABEL: 'Phone number',
    SUBMIT_CTA: 'Send code',
    DEV_MENU: 'Dev Menu'
};
exports.DEV_AUTH = __assign(__assign({}, exports.PHONE_AUTH), { RESET_ACCOUNT: 'Reset the account associated with this phone number', SUBMIT_CTA: 'Continue' });
